var config = {
  devRestApiURL: "api/",
  restApiURL: "api/"
};

export { config };